module.exports = __webpack_public_path__ + "img/home-huize.9a489925.png";